import CampaignsList from './CampaignsList';

export type { CampaignsListProps } from './CampaignsList';

export default CampaignsList;
